import { SearchFilterConditionDate } from 'lib-shared-types-api';

import { ConditionFieldProps } from '../../conditionField';

import { ConditionFieldDateRange } from './components/conditionFieldDateRange';
import { ConditionFieldDateSingle } from './components/conditionFieldDateSingle';

/**
 * Represents a component that can be used to visualize a date or a date range
 * filter
 */
export const ConditionFieldDate = (
  props: ConditionFieldProps<SearchFilterConditionDate>,
): JSX.Element => {
  const { condition } = props;
  const isRange = condition.operator === 'between';

  if (isRange) {
    return <ConditionFieldDateRange {...props} />;
  }
  return <ConditionFieldDateSingle {...props} />;
};
